module.exports = {"140430100":"定昌镇","140430101":"郭村镇","140430102":"故县镇","140430103":"新店镇","140430104":"漳源镇","140430105":"册村镇","140430200":"段柳乡","140430201":"松村乡","140430202":"次村乡","140430203":"牛寺乡","140430204":"南里乡","140430205":"南泉乡","140430206":"杨安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140430.json
// module id = 266
// module chunks = 0